import { Dialog, DialogActions, DialogContent, TextField, Button } from "@mui/material";
import DialogTitleWithCloseButton from "../../../../components/DialogTitleWithCloseButton";
import { LOAN_STATUS } from "../../../../../../shared/constants";
import request from "../../../../request";
import { hideLoading, showLoading } from "../../../../loading";
import { errorToast } from "../../../../toast";
import swal from 'sweetalert';


export default function ApproveRejectModal(props) {

   return <Dialog open>
      <DialogTitleWithCloseButton onClose={props.onClose}>
         { props.status === LOAN_STATUS.APPROVED ? 'Approve' : 'Reject' } Loan
      </DialogTitleWithCloseButton>

      <DialogContent dividers>
         <div className="space-y-4">
            {
               props.status === LOAN_STATUS.APPROVED && <TextField
                  id="txt-annual-rate"
                  label="Annual Rate (%)"
                  type="number"
                  size="small"
                  variant="outlined"
                  fullWidth
               />
            }

            <TextField
               id="txt-notes"
               label="Notes"
               multiline
               size="small"
               variant="outlined"
               fullWidth
            />
         </div>
      </DialogContent>

      <DialogActions>
         <Button
            variant="contained"
            size="small"
            onClick={
               async () => {
                  // extract values from form
                  const txtAnnualRate = document.getElementById('txt-annual-rate');
                  const txtNotes = document.getElementById('txt-notes');

                  const annual_rate = txtAnnualRate?.value;
                  const notes = txtNotes.value;

                  // validate
                  if (props.status === LOAN_STATUS.APPROVED && !annual_rate) {
                     errorToast('Annual Rate is required');
                     return txtAnnualRate.focus();;
                  }

                  if (!notes) {
                     errorToast('Notes is required');
                     return txtNotes.focus();
                  }

                  // send request
                  try {

                     showLoading();

                     const payload = {
                        status: props.status,
                        annual_rate,
                        notes,
                     }

                     const res = await request
                        .patch(`/api/finance/loans/${props.loanId}` , payload);

                     props.onClose(res.data);
                  } catch (err) {
                     swal("Error", err.message, "error");
                  } finally {
                     hideLoading();
                  }
               }
            }
         >
            { props.status === LOAN_STATUS.APPROVED ? 'Approve' : 'Reject' }
         </Button>
      </DialogActions>
   </Dialog>
}